// extracted by mini-css-extract-plugin
export var askAiIcon = "_pr-9";
export var container = "_pr-0";
export var groupSeparator = "_pr-a";
export var highlight = "_pr-4";
export var resultIcon = "_pr-5";
export var resultItem = "_pr-7";
export var resultSubtitle = "_pr-3";
export var resultTitle = "_pr-2";
export var resultsList = "_pr-1";
export var searchGroup = "_pr-6";
export var selected = "_pr-8";